import {
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UniversityService } from '../../services';
import { UniversityResponse } from '../../types';

@Component({
  selector: 'app-university-page',
  templateUrl: './university-page.component.html',
})
export class UniversityPageComponent implements OnInit {
  @HostBinding('class.table-page-component')
  hostClass = true;
  search = '';

  constructor(
    private service: UniversityService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.service.loadList();
  }

  get items(): UniversityResponse[] {
    const language = this.translate.currentLang || 'de';
    const search = this.search.trim().toLocaleLowerCase();
    return [...this.service.items]
      .filter((item) =>
        Object.values(item.names).some((name) =>
          name.toLocaleLowerCase().includes(search)
        )
      )
      .sort((a, b) =>
        this.name(a, language).localeCompare(
          this.name(b, language)
        )
      );
  }

  get loading(): boolean {
    return this.service.listLoading;
  }

  name(
    item: UniversityResponse,
    language?: string
  ): string {
    return (
      item.names[language || this.translate.currentLang] ||
      item.names.de ||
      item.names.en ||
      item.translationKey
    );
  }
}
